import * as React from "react";
import { useState, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import { Box, Dialog } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { loginApi } from "../../services/authApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function RegisterStep3(props) {
  const {
    disableButton,
    userName,
    handleRegisterStep3Submit,
    handleShowingFormsValues,
    customToastify,
  } = props;

  const [userPassword, setUserPassword] = useState("");
  const [confirmUserPassword, setConfirmUserPassword] = useState("");

  const handleClickSubmit = (e) => {
    if (userPassword.length < 7)
      customToastify("error", "کلمه عبور حداقل باید 8 کاراکتر باشد");
    if (userPassword.length > 255)
      customToastify("error", "کلمه عبور حداکثر باید 255 کاراکتر باشد");
    if (userPassword !== confirmUserPassword)
      customToastify("error", "کلمه عبور و تکرار آن یکی نمی باشد");
    else handleRegisterStep3Submit({ userPassword, confirmUserPassword });
  };
  return (
    <Box
      sx={{
        marginTop: 0.5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Avatar sx={{ m: 0.5, bgcolor: "secondary.main" }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography
        component="h1"
        color="darkgoldenrod"
        sx={{ textAlign: "center" }}
        variant="body1"
      >
        لطفا پسوردی برای خود تعیین کنید
      </Typography>
      <Box>
        <Typography sx={{ textAlign: "center" }}>
          نام کاربری:{userName}
        </Typography>
      </Box>
      <Box>
        <Typography
          sx={{ fontSize: ".8rem", color: "#f76565", textAlign: "center" }}
        >
          نام کاربری و دیگر مشخصات خود را از بخش پروفایل می توانید تغییر دهید
        </Typography>
      </Box>
      <Box noValidate sx={{ mt: 1 }}>
        <TextField
          //   margin="normal"
          sx={{ m: 0.3 }}
          required
          fullWidth
          id="userPassword"
          label="کلمه عبور"
          name="userPassword"
          type="password"
          value={userPassword}
          onChange={(e) => setUserPassword(e.target.value)}
          autoComplete="userPassword"
        />
        <TextField
          //   margin="normal"
          sx={{ m: 0.3 }}
          required
          fullWidth
          id="confirmUserPassword"
          label="تکرار کلمه عبور"
          type="password"
          name="confirmUserPassword"
          value={confirmUserPassword}
          onChange={(e) => setConfirmUserPassword(e.target.value)}
          autoComplete="confirmUserPassword"
        />
        <Button
          disabled={disableButton}
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 1, mb: 1 }}
          onClick={handleClickSubmit}
        >
          ادامه
        </Button>
        <Grid container>
          <Container maxWidth="sx">
            <Link
              href="#"
              onClick={() => {
                handleShowingFormsValues("11");
              }}
              variant="body2"
            >
              {"قبلا ثبت نام کرده ام!"}
            </Link>
          </Container>
          <Container maxWidth="sx">
            <Link
              href="#"
              onClick={() => {
                handleShowingFormsValues("111");
              }}
              variant="body2"
            >
              {"تغییر شماره ثبت نام"}
            </Link>
          </Container>
          <Container maxWidth="sx"></Container>
        </Grid>
      </Box>
    </Box>
  );
}
